export default {
  envName: 'stage',
  baseURL: 'https://stageapi.frontm.ai',
  filesAPI: 'https://gwuat.frontm.ai/proxy/resource',
  contentURL: 'https://gwuat.frontm.ai/proxy/botLogos/',
  botFilesAPI: 'https://gwuat.frontm.ai/proxy/resource/botfile?path=',
  soundURL: 'https://gwuat.frontm.ai/proxy/sounds/',
  gRPCURL: 'https://gwuat.frontm.ai',
  webertcSignalServer: 'gwuat.frontm.ai',
  mapURL: 'https://maps.frontm.ai/styles/klokantech-basic/style.json',
  sipURI: 'frontmsecureweb@pstn-prod.frontm.ai',
  sipPassword: 'frontm@123^%',
  sipWebsocket: 'wss://pstn-prod.frontm.ai:8089/ws',
  dailyPlatformUrl: 'https://frontm.daily.co/',
  daily_baseUrl: 'https://x7kuu4sb32.execute-api.us-east-1.amazonaws.com/item/video',
  xApiKey: 'h5o30iCFCU2wX3gQ59FH137cSj19Uwwd2W9DSnrL',
  userImageBaseUrl: "https://gwuat.frontm.ai/proxy/resource/file/profile-pics",
  TokenSecretKey: "4DjEEHV4feUWpvJARMSAEJ4E7JDOwUtQ7F6YYd21SQMJyM1TPoCjLeFAUe3vpQceWmGRrJRdh1z",
  defaultHomePagebaseUrl: "spinnetstage.frontm.ai",
  googleClientId: '767424496456-usre4ikl1guv19kjd3tviqjo443m4o74.apps.googleusercontent.com',
  websocketURL: 'wss://u8wr9j1kv8.execute-api.us-east-1.amazonaws.com/stage/',
  webSocketAPiKey: 'h5o30iCFCU2wX3gQ59FH137cSj19Uwwd2W9DSnrL',
  wpsGatewayRestApiKey: "https://5glogmvnrk.execute-api.us-east-1.amazonaws.com/stage",
  vikandWebPushKey: 'BALL99Nj7_YDxBotBgsTPE47jI1rN9R7li57Z4uXtEaXYhIZmFBfoU0O_6yHlxHgHkZkf5hFmF74I4K4zHz80oY',
  seamedexWebPushKey: 'BDOXonaa5d3w04NaP6VwHKLE2-wkOXBlzsQl17r7HdMX_FpbqlLZcxS48htgA-JUH22ay2ges45YZEb2G_8VaME',
  jwtLoginURL: 'https://5glogmvnrk.execute-api.us-east-1.amazonaws.com/stage',
  xApiKeyForJwtLogin: 'h5o30iCFCU2wX3gQ59FH137cSj19Uwwd2W9DSnrL',
   dailyXApiKey:"eJkQnb8KBy6woeUpoIaWr8r1j3YYyi6738UNNEdj",
  //Apptypes
  stationoneAppType: "stationsatcom",
  onshipAppType: "onship",
  vikandWebAppType: "vikand",
  seamedexAppType: "seamedix",
  seadanceAppType: "seadance",
  intelsatAppType: "intelsat",
  ledgidAppType: "ledgid",

  //authCode
  onshipDomain: 'onshipEndUser',
};
